import React, {
    useState,
    useEffect,
} from "react";
import {useDispatch, useSelector} from 'react-redux';

import {
    Row,
    Col,
    Image,
    Tooltip,
    Popover,
    Button,
    Badge
} from 'antd';
import {
    FilterOutlined,
    CheckOutlined,
} from '@ant-design/icons';

import * as T from 'utils/types';

import {
    SDGs,
    clearSDGFilterIcon,
} from "assets/svgs/SDG_icons";
import searchPgUserInputsS from 'features/content/search_page/UserInputsSlice';

export default () => {
    const [SDGFiltersVisible, setSDGFiltersVisible] = useState(false);
    const dispatch = useDispatch();

    const {
        rsrSpecific: { SDGs: SDGs_selected }
    } = useSelector((state: T.RootState) => state.searchPgUserInputs);

    const {
        SDG
    } = useSelector((state: T.RootState) => state.rsrFilter);

    useEffect(() => {
        return () => {
            dispatch(searchPgUserInputsS.actions.setSDG(0));
        };
    }, [dispatch]);


    const getSDGFiltersComponent = (): JSX.Element => {
        // Assumption: SDG.length === 17
        let SDGStatsVector = [0];
        if (SDG?.statInfo?.statVec?.length > 0) {
            SDGStatsVector = SDGStatsVector.concat(SDG.statInfo.statVec);
        } else {
            SDGStatsVector = SDGStatsVector.concat(new Array(17).fill(0));
        }

        const resetSDG = {
            index: 0,
            icon: clearSDGFilterIcon,
            goal: 'Reset filter',
        };
        const SDG6by3matrix = SDGs.reduce( (previousValue, currentValue) => {
            // [
            //     [ 0, 1, 2 ],
            //     [ 3, 4, 5 ],
            //     [ 6, 7, 8 ],
            //     [ 9, 10, 11 ],
            //     [ 12, 13, 14 ],
            //     [ 15, 16, 17 ]
            // ]
            const index = Math.floor(currentValue.index / 3);

            if (currentValue.index % 3 === 0) {
                previousValue[index] = [currentValue];
            } else {
                previousValue[index].push(currentValue);
            }
            return previousValue;
        }, [[resetSDG], [], [], [], [], []]);

        return <> {SDG6by3matrix.map( (SDGRow, rowIndex) => 
                <Row key={rowIndex} gutter={[8, 4]} justify="space-around" align="top" wrap={false}>
                    {SDGRow.map((sdgItem, colIndex) => {
                        const tooltipTitle = sdgItem.index === 0 ? sdgItem.goal : `${sdgItem.goal} (${SDGStatsVector[sdgItem.index]})`;
                        const isSelected = SDGs_selected.includes(sdgItem.index);
                        const badge = isSelected ? <CheckOutlined style={{ color: '#52c41a', fontSize: 36, top: 8, right: 16, }} /> : <></>;
                        const imageClassName = isSelected ? 'sdg-filters sdg-filter-selected' : 'sdg-filters';
                        // For mobile devices with narrow width (e.g. Galaxy Fold's width is 280), use width narrower than default (100)
                        // SDG container's width is 348 with default imageWidth of 100
                        const defaultImageWidth = 100;
                        const imageWidth = Math.min((window.innerWidth - 48) / 3, defaultImageWidth);

                        return <Col key={colIndex}>
                            <Tooltip
                                overlayClassName="sub-heading-font"
                                title={tooltipTitle}
                            >
                                <Badge count={badge}>
                                    <Image
                                        className={imageClassName}
                                        width={imageWidth}
                                        src={sdgItem.icon}
                                        preview={false}
                                        onClick={() => {
                                            dispatch(searchPgUserInputsS.actions.setSDG(sdgItem.index));
                                        }}
                                    />
                                </Badge>
                            </Tooltip>
                        </Col>;
                    })}
                </Row>
        )} </>; 
    };

    return <Popover
        content={getSDGFiltersComponent()}
        placement="bottomRight"
        trigger="click"
        visible={SDGFiltersVisible}
        onVisibleChange={setSDGFiltersVisible}
    >
        <Button
            className="sub-heading-font full-width"
            icon={<FilterOutlined />}
            loading={SDG?.status==="loading"}
            disabled={SDG?.status==="loading"}
            style={{ marginBottom: 8, textAlign: 'start', padding: '4px 11px' }}
        >
            {SDGs_selected.length > 0 
            ?  (SDGs_selected.length === 1 
                ? SDGs[SDGs_selected?.[0] - 1]?.goal 
                : `SDG ${SDGs_selected.join(', ')}`) 
            :  'Sustainable Development Goals'}
        </Button>
    </Popover>;
}

